const SkeletonStatCard = () => (
  <div className="skeleton-card" style={{ display: 'flex', alignItems: 'center', gap: 14, padding: 18, borderRadius: 10 }}>
    <div className="skeleton" style={{ width: 42, height: 42, borderRadius: 14, flexShrink: 0 }} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <div className="skeleton" style={{ height: 14, width: '60%', marginBottom: 8 }} />
      <div className="skeleton" style={{ height: 22, width: '80%' }} />
    </div>
  </div>
);

const SkeletonPropertyCard = () => (
  <div className="skeleton-card" style={{ padding: 0, overflow: 'hidden', borderRadius: 10 }}>
    <div className="skeleton" style={{ height: 230, width: '100%', borderRadius: 0 }} />
    <div style={{ padding: '14px' }}>
      <div className="skeleton" style={{ height: 16, width: '85%', marginBottom: 8 }} />
      <div className="skeleton" style={{ height: 22, width: '60%', marginBottom: 10 }} />
      <div className="skeleton" style={{ height: 12, width: '70%', marginBottom: 10 }} />
      <div style={{ display: 'flex', gap: 5, marginBottom: 10 }}>
        <div className="skeleton" style={{ height: 24, width: 60, borderRadius: 6 }} />
        <div className="skeleton" style={{ height: 24, width: 60, borderRadius: 6 }} />
        <div className="skeleton" style={{ height: 24, width: 60, borderRadius: 6 }} />
      </div>
      <div className="skeleton" style={{ height: 1, width: '100%', marginBottom: 10 }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 12 }}>
        <div className="skeleton" style={{ width: 26, height: 26, borderRadius: '50%' }} />
        <div className="skeleton" style={{ height: 12, width: '40%' }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div className="skeleton" style={{ height: 36, width: '100%', borderRadius: 8 }} />
        <div style={{ display: 'flex', gap: 6 }}>
          <div className="skeleton" style={{ height: 36, flex: 1, borderRadius: 8 }} />
          <div className="skeleton" style={{ height: 36, flex: 1, borderRadius: 8 }} />
        </div>
      </div>
    </div>
  </div>
);

const SkeletonFilterToolbar = () => (
  <div className="skeleton-section-card" style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
    <div className="skeleton" style={{ height: 48, flex: 1, minWidth: 260, borderRadius: 14 }} />
    <div className="skeleton" style={{ height: 48, width: 200, borderRadius: 14 }} />
    <div className="skeleton" style={{ height: 48, width: 200, borderRadius: 14 }} />
    <div className="skeleton" style={{ height: 48, width: 120, borderRadius: 14 }} />
  </div>
);

const DashboardPropertiesSkeleton = () => (
  <section className="dashboard-page">
    <div className="dashboard-page__header">
      <div>
        <div className="skeleton" style={{ height: 30, width: 200, marginBottom: 8 }} />
        <div className="skeleton" style={{ height: 16, width: 260 }} />
      </div>
      <div className="skeleton" style={{ height: 48, width: 170, borderRadius: 14 }} />
    </div>

    <div className="dashboard-stats">
      {Array.from({ length: 4 }).map((_, i) => (
        <SkeletonStatCard key={i} />
      ))}
    </div>

    <SkeletonFilterToolbar />

    <div className="property-grid">
      {Array.from({ length: 8 }).map((_, i) => (
        <SkeletonPropertyCard key={i} />
      ))}
    </div>
  </section>
);

export default DashboardPropertiesSkeleton;
